import I18n from "i18n-js";
import {Button} from "@mui/material";
//@ts-ignore
import x from "assets/x.svg";

export interface XShareProps {
  url: string;
  text?: string;
}
export default function XShare({url, text}: XShareProps) {
  const shareUrl = `https://x.com/intent/post?url=${encodeURIComponent(url)}&text=${encodeURIComponent(I18n.t("SocialShare.x.shareText"))}`;
  if (!text) {
    text = I18n.t("SocialShare.x.defaultText");
  }

  return (
    <Button
      startIcon={
        <img
          src={x}
          width={16}
          height={16}
        />
      }
      fullWidth={false}
      href={shareUrl}
      target="_blank"
      sx={{
        minHeight: "32px",
        color: "#FFFFFF",
        backgroundColor: "#000000",
        lineHeight: "1",
        width: "auto",
        marginRight: "5px",
        ":hover": {
          backgroundColor: "#1a1a1a",
        }
      }}
    >
      {text}
    </Button>
  );
}